import type React from 'react';
import { useEffect } from 'react';
import { Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useRecoilState } from 'recoil';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { Card, Form } from 'components';
import { ResellersSelect } from 'components/form/select/ResellersSelect';
import { Period } from '@enmon/commons/lib/enmon';
import { PeriodSelect } from 'components/form/select/PeriodSelect';
import { periodOptions } from 'common';
import { type ResellersFilterType, resellersFilter } from '../store/filter';

const PERIOD_SELECTION = [Period.Last3months, Period.Last12months, Period.Last24months];
const filteredPeriodOptions = PERIOD_SELECTION.map(period => periodOptions.find(({ value }) => value === period));

export const ResellersFilter: React.VFC = () => {
  const [form] = useForm();
  const [filter, setFilter] = useRecoilState(resellersFilter);

  const onFinish = (values: Pick<ResellersFilterType, 'customer'>) => {
    setFilter({ ...filter, ...values });
  };

  const handleReset = () => {
    setFilter({
      ...filter,
      customer: undefined,
      period: Period.Last24months,
    });
  };

  useEffect(() => {
    form.setFieldsValue(filter);
  }, [filter, form]);

  return (
    <Card>
      <Form form={form} initialValues={filter} layout="inline" onFinish={onFinish}>
        <Space wrap>
          <Form.Item label="Reseller" name="customer" style={{ marginBottom: 0 }}>
            <ResellersSelect placeholder="Choose reseller" style={{ minWidth: 200 }} />
          </Form.Item>
          <Form.Item label="Period" name="period" style={{ marginBottom: 0 }}>
            <PeriodSelect options={filteredPeriodOptions} style={{ minWidth: 200 }} />
          </Form.Item>
          <FilterControlButtons onClickReset={handleReset} />
        </Space>
      </Form>
    </Card>
  );
};
